export interface EvaluationScore {
  cp: number | null;
  mate: number | null;
}

export const formatEvaluation = (evaluation: EvaluationScore | null): string => {
  if (!evaluation || (evaluation.cp == null && evaluation.mate == null)) return "Unknown";
  if (evaluation.mate != null) return `${evaluation.mate > 0 ? "M" : "-M"}${Math.abs(evaluation.mate)}`;
  const cp = evaluation.cp!;
  if (Math.abs(cp) === 10_000) return "Unknown";
  const absolute = Math.abs(cp);
  const pawns = cp !== 0 && absolute < 10 ? (absolute / 100).toFixed(2) : (Math.round(absolute / 10) / 10).toFixed(1);
  return `${cp > 0 ? "+" : cp < 0 ? "-" : ""}${pawns}`;
};
